module.exports = __webpack_public_path__ + "img/solaredge.8abb742a.png";